<template>
  <div :id="expandContentId" :aria-hidden="isExpanded(expandContentId) ? 'false' : 'true'" class="">
    <slot />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useExpandersStore } from '@/stores/expanders'

/**
 * Generic expand toggle that uses pinia to open an expander that is not
 * connected in the DOM.
 *
 * USE CASE 1 - Cart Views
 * - expand toggle is in a separate section
 * - expand content is in a separate / lower section
 * - pinia handles the state for expand / collapse by an ID map
 */
export default {
  name: 'ExpandStatsContent',
  components: {},
  props: {
    expandContentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(useExpandersStore, ['isExpanded']),
  },
  methods: {},
}
</script>
